import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ScheduleBooking from './ScheduleBooking';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import { closeCancelManualBookingModal, closeCancelBookingModal } from '../../../actions/siteadmin/modalActions';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.scheduleBooking);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;
    store.dispatch(closeCancelManualBookingModal())
    store.dispatch(closeCancelBookingModal())
    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/schedule-bookings', adminPrivileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <ScheduleBooking />
            </AdminLayout>
        ),
    }
}

export default action;